import { render, staticRenderFns } from "./CommonContactInfo.vue?vue&type=template&id=50a644cc&"
import script from "./CommonContactInfo.vue?vue&type=script&lang=js&"
export * from "./CommonContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports